import CustomEvent from 'lib/CustomEvent';
import Main from 'controllers/Main';
import TransitionController from 'controllers/TransitionController';


export default new class extends CustomEvent {

	constructor() {
		super();

		this.classes = {};
	}


	init() {
		this._bindEvents();
	}


	register(slug, _class) {
		this.classes[slug] = _class;
	}


	update($dom) {
		$dom.find('[data-component]').not('[data-component-init]').each((index, $item) => this._addComponent($item));
	}


	destroy($dom) {
		if ($dom._LA_componentJsClass && $dom._LA_componentJsClass.length > 0) {
			$dom._LA_componentJsClass.map(componentClassInstance => {
				componentClassInstance.destroy();
			});
		}
	}


	_bindEvents() {
		TransitionController.on(TransitionController.E.INIT_BLOCKS, this._init, this);
		TransitionController.on(TransitionController.E.DESTROY_BLOCKS, this._destroy, this);
	}


	_init() {
		Main.$body.find('[data-component]').not('[data-component-init]').each((index, $item) => this._addComponent($item));
	}


	_addComponent($dom) {
		const components = $dom.getAttribute('data-component').split(' ');
		$dom._LA_componentJsClass = [];
		components.map(componentName => {

			if (!this.classes[componentName]) {
				console.warn('Components | Class "' + componentName + '"" not found');

				return;
			}

			$dom.setAttribute('data-component-init', true);

			$dom._LA_componentJsClass.push(new this.classes[componentName]($($dom)));
		});
	}


	_destroy($dom) {
		$dom.find('[data-component-init]').each((index, $item) => {
			$item._LA_componentJsClass.map(componentClassInstance => {
				// console.log("to destroy", componentClassInstance);
				componentClassInstance.destroy();
				componentClassInstance = null;
			});
		});
	}


};

